import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ColumnDef, PageOptions } from 'src/app/shared/data-table/data-table.interface';
import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { EcmService } from '../../../ecm.service';
import { EcmPartsService } from '../ecm-parts.service';
import { ToastrService } from 'ngx-toastr';
import { LazyLoadEvent } from 'primeng/api/lazyloadevent';

@Component({
  selector: 'ecm-parts-supersede',
  templateUrl: './ecm-parts-supersede.component.html',
  styleUrls: ['./ecm-parts-supersede.component.scss']
})
export class EcmPartsSupersedeComponent implements OnInit {

  newPart = true;
  part: any;
  selectedPart: any;

  parts: any = [];
  total = 0;

  partSupersedeForm = new UntypedFormGroup({
    newPartNumber: new UntypedFormControl('', Validators.maxLength(8)),
    oppositePartNumber: new UntypedFormControl('', Validators.maxLength(8))
  });

  constructor(
    private readonly dialogRef: MatDialogRef<EcmPartsSupersedeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly ecmPartsService: EcmPartsService,
    private readonly toastr: ToastrService) { }

  ngOnInit() {
    this.part = this.data;

    this.ecmPartsService.getParts()
      .subscribe(data => this.parts = data);
  }

  save() {
    if (this.newPart) {
      if (!this.partSupersedeForm.valid) {
        this.toastr.error('Please fill out all required fields.');
        return;
      }

      const data = this.partSupersedeForm.value;
      data.newPartNumber = data.newPartNumber.toUpperCase();
      if (data.oppositePartNumber != null) {
        data.oppositePartNumber = data.oppositePartNumber.toUpperCase();
      }

      this.ecmPartsService.supersedePart(false, data.oppositePartNumber || '', data.newPartNumber, this.part.partId, this.part.partNumber)
        .subscribe(
          this.dialogRef.close.bind(this.dialogRef, this.part),
          () => this.toastr.error(`Failed to supersede part ${this.part.partNumber}`),
          () => this.toastr.success('Part successfully superseded'),
        );
    } else {
      if (!this.selectedPart) {
        this.toastr.error(`Please select a part to supersede ${this.part.partNumber}`);
        return;
      }

      const data = this.selectedPart;

      this.ecmPartsService.supersedePart(true, '', '', this.part.partId, '', data.partId)
        .subscribe(
          this.dialogRef.close.bind(this.dialogRef, this.part),
          () => this.toastr.error(`Failed to supersede part ${this.part.partNumber}`),
          () => this.toastr.success('Part successfully superseded'),
        );
    }
  }

  get hasEnabledFields(): boolean {
    const val = this.partSupersedeForm.get('newPartNumber').value;
    return (!this.newPart && this.selectedPart) || (val && val.trim() && val.length <= 8);
  }

  close() {
    this.dialogRef.close(this.part);
  }
}
